export enum Locale {
  EN = 'en',
  DE = 'de',
  NL = 'nl',
}
